import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { ISchedules } from "./models";
import { scheduleItems } from "./schedule.mock";
import { memo, useCallback, useState } from "react";
import { Schedule } from "./ScheduleForm/Schedule";

const translationPath = "page.4uDlist.generationRule.schedule.";

export const SchedulePage = memo(() => {
  const [schedule, setSchedule] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const columns: GridColDef<ISchedules>[] = [
    {
      field: "identifier",
      headerName: t(translationPath + "identifier") || "Identifier",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setSchedule(true);
  };

  const handleRowClick = (params: GridRowParams<ISchedules>) => {
    if (!params.row) return;
    setSchedule(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setSchedule(false);
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {schedule && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Schedule id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!schedule && (
        <Box height={600}>
          <Table<ISchedules>
            showDefaultMacroFilters={false}
            rows={scheduleItems}
            columns={columns}
            title={t(translationPath + "schedules")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={
              t(translationPath + "add_schedule") || "Add Schedule"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
